import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import CustomTableHead from "../components/CustomTableHead";
import PopupMessage from "../components/PopupMessage";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import AchDispositionDetails from "../details/AchDispositionDetails";

import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import ConfirmDialog from "../components/ConfirmDialog";

import CustomPaginatorActions from "../components/CustomPaginatorActions";
import TablePagination from "@material-ui/core/TablePagination";

import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  customWidth: {
    maxWidth: 500,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  { id: "date", numeric: false, disablePadding: true, label: "Date" },
  { id: "trace", numeric: false, disablePadding: true, label: "Trace" },
  { id: "checkNumber", numeric: false, disablePadding: true, label: "Check#" },
  { id: "code", numeric: false, disablePadding: true, label: "Code" },
  { id: "type", numeric: false, disablePadding: true, label: "Type" },
  { id: "crdr", numeric: false, disablePadding: true, label: "CR/DR" },
  { id: "transSerial", numeric: false, disablePadding: true, label: "Serial#" },
  { id: "amount", numeric: true, disablePadding: false, label: "Amount($)" },
  { id: "status", numeric: false, disablePadding: true, label: "Status" },
  {
    id: "nosort_action",
    numeric: false,
    disablePadding: true,
    label: "Action",
  },
  {
    id: "transit",
    numeric: false,
    disablePadding: true,
    label: "Orig Transit",
  },
  { id: "nosort", numeric: false, disablePadding: true, label: "More..." },
];

class AchExceptionHomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      inited: false,
      order: "asc",
      orderBy: "0",
      items: [],
      selectedItem: {},
      selectedItemIndex: -1,
      viewAddPolicyConfirm: false,
      viewEditAction: false,
      viewPopup: false,
      searchInProgress: false,
      totalCount: 0,
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onDispositionSave = this.onDispositionSave.bind(this);
    this.handleConfirmPolicySave = this.handleConfirmPolicySave.bind(this);
  }

  componentDidMount() {
    /*this.setState({ searchInProgress: true });
    this.props.account.secureToken = this.props.secureToken;
    fetch("on_ach_exception_home_page_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.props.account),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          let newData = reply.data;
          this.setState({ items: newData });
          this.setState({ totalCount: reply.totalCount });
          this.setState({ totalAmount: reply.totalAmount });
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          } else {
            this.setState({ inited: true });
          }
        }
        this.setState({ searchInProgress: false });
      })
      .catch((error) => {
        this.setState({ searchInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });*/
    this.homeSearch(0, this.state.rowsPerPage);
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    this.homeSearch(0, e.target.value);
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    this.homeSearch(page, this.state.rowsPerPage);
  };

  homeSearch(page, rowsPerPage) {
    this.setState({ searchInProgress: true });
    var account = this.props.account;
    account.secureToken = this.props.secureToken;
    account.compId = this.props.compId;
    account.page = page;
    account.num_items = rowsPerPage;
    fetch("on_ach_exception_home_page_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(account),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          let newData = reply.data;
          this.setState({ items: newData });
          this.setState({ totalCount: reply.totalCount });
          this.setState({ totalAmount: reply.totalAmount });
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          } else {
            this.setState({ inited: true });
          }
        }
        this.setState({ searchInProgress: false });
      })
      .catch((error) => {
        this.setState({ searchInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (
        orderBy === "checkNumber" ||
        orderBy === "trace" ||
        orderBy === "transSerial" ||
        orderBy === "transit"
      ) {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "amount") {
        data.sort(getFloatSorting(order, "rawAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewEditAction: false });
    this.setState({ viewAddPolicyConfirm: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  onDispositionSave(disp, notes) {
    let items = this.state.items;
    if (items.length === 1) {
      this.props.onClose(null);
    } else {
      items.splice(this.getItemIndex(this.state.selectedItemIndex), 1);
      this.setState({ items: items });
      this.setState({ viewEditAction: false });
    }
  }

  handleEditAction(event, itemIndex) {
    let item = this.state.items[this.getItemIndex(itemIndex)];
    this.setState({ selectedItemIndex: itemIndex });
    this.setState({ selectedItem: item });
    this.setState({ viewEditAction: true });
  }

  handleAddPolicy(event, itemIndex) {
    let item = this.state.items[this.getItemIndex(itemIndex)];
    this.setState({ selectedItemIndex: itemIndex });
    this.setState({ selectedItem: item });
    this.setState({ viewAddPolicyConfirm: true });
  }

  handleConfirmPolicySave(event, action) {
    this.setState({ viewAddPolicyConfirm: false });
    if (action === 1) {
      fetch("on_authorize_ach_exception", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.account.transit,
          account: this.props.account.account,
          item: this.state.selectedItem,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            let items = this.state.items;
            items[
              this.getItemIndex(this.state.selectedItemIndex)
            ].canSetPolicy = false;
            //					this.setState({items: items});
            this.setState({
              notifyString: "The ACH Exception action data have been modified.",
            });
            this.setState({ viewPopup: true });
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
  }

  getItemIndex(objectIndex) {
    let items = this.state.items;
    let i;
    for (i = 0; i < items.length; i++) {
      if (items[i].index === objectIndex) {
        return i;
      }
    }
    return objectIndex;
  }
  handleUnselectAccount(e) {
    this.props.onClose();
  }

  render() {
    const { classes } = this.props;
    const { order, orderBy } = this.state;
    let items = this.state.items;
    let { t } = this.props;
    const { rowsPerPage, page, totalCount } = this.state;
    return (
      <div>
        {this.state.viewEditAction && (
          <AchDispositionDetails
            secureToken={this.props.secureToken}
            viewOnly={this.props.viewOnly}
            history={this.props.history}
            onClosePopup={this.onClosePopup}
            accountObject={this.props.account}
            item={this.state.selectedItem}
            onDispositionSave={this.onDispositionSave}
          />
        )}

        {this.state.viewAddPolicyConfirm && (
          <ConfirmDialog
            title={t("confirmAddPolicy.label")}
            text={t("saveAchPolicy.label")}
            onCloseConfirm={this.handleConfirmPolicySave}
          />
        )}

        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.totalCount === 0 &&
          this.state.errorString.length === 0 &&
          this.state.searchInProgress && (
            <div>
              <br></br>
              <CircularProgress className={classes.progress} />
            </div>
          )}

        {this.state.inited && (
          <div>
            {this.state.totalCount > 0 && !this.state.searchInProgress && (
              <div>
                <Typography variant="h6" color="primary" style={{ margin: 20 }}>
                  {t("achExceptions.label")}
                </Typography>
                <Typography variant="body1" color="primary">
                  &nbsp;&nbsp;{t("selectedTransit.label")}&nbsp;
                  <span>
                    <strong>{this.props.account.transit}</strong>
                  </span>
                  &nbsp;&nbsp;{t("account.label")}&nbsp;
                  <span>
                    <strong>{this.props.account.account}</strong>
                  </span>
                  &nbsp;&nbsp;
                  <Button
                    color="primary"
                    onClick={(event) => this.handleUnselectAccount(event)}
                  >
                    <DeselectIcon />
                    &nbsp;{t("deselect.button")}
                  </Button>
                </Typography>

                <Paper>
                  <TablePagination
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={(event) =>
                      this.handleChangeRowsPerPage(event)
                    }
                    ActionsComponent={CustomPaginatorActions}
                  />
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {items.map((n) => {
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            key={n.index}
                          >
                            <TableCell>{n.date}</TableCell>
                            <TableCell>{n.trace}</TableCell>
                            <TableCell>{n.checkNumber}</TableCell>
                            <TableCell>{n.code}</TableCell>
                            <TableCell>{n.type}</TableCell>
                            <TableCell>{n.crDr}</TableCell>
                            <TableCell>{n.transSerial}</TableCell>
                            <TableCell numeric={true}>{n.amount}</TableCell>
                            <Tooltip title={t("notes.label") + ": " + n.notes}>
                              <TableCell>{n.status}</TableCell>
                            </Tooltip>
                            <TableCell>
                              <Button
                                size="small"
                                color="primary"
                                disabled={
                                  !n.canDisposition ||
                                  this.props.minutesLeft < 0
                                }
                                onClick={(event) =>
                                  this.handleEditAction(event, n.index)
                                }
                              >
                                {t("disposition.button")}
                              </Button>
                              <br />
                              {n.canSetPolicy && this.props.minutesLeft > 0 && (
                                <Button
                                  style={{
                                    margin: 0,
                                    padding: 0,
                                    minWidth: 0,
                                    minHeight: 0,
                                  }}
                                  size="small"
                                  color="primary"
                                  /*disabled={
                                    !n.canSetPolicy || this.props.minutesLeft < 0
                                  }*/
                                  title={t("saveNewPolicy.tip")}
                                  onClick={(event) =>
                                    this.handleAddPolicy(event, n.index)
                                  }
                                >
                                  {t("addPolicy.button")}
                                </Button>
                              )}
                            </TableCell>
                            <TableCell>{n.transit}</TableCell>
                            <Tooltip
                              classes={{ tooltip: classes.customWidth }}
                              title={
                                <div>
                                  {t("orig.label")}: {n.originator} <br />
                                  {t("companyName.header")}: {n.compName} <br />
                                  {t("compId.label")}: {n.compId} <br />
                                  {t("description.header")}: {n.compDescr}{" "}
                                  <br />
                                  {t("payInfo.label")}: {n.payInfo} <br />
                                  {t("notes.label")}: {n.notes}
                                  {n.locked && (
                                    <div>
                                      {t("lockedBy.label")}: {n.lockedBy}
                                    </div>
                                  )}
                                </div>
                              }
                            >
                              <TableCell style={{ width: "6%" }}>
                                <InfoIcon color="primary" />
                              </TableCell>
                            </Tooltip>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(AchExceptionHomePage));
